import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, ArrowLeft, Clock, Calendar } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { fetchArticle } from "@/lib/api";
import LeadForm from "@/components/LeadForm";

export default function ArticleDetail() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchArticle(slug)
      .then(setArticle)
      .catch(() => setArticle(null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="pt-32 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  if (!article) return (
    <div className="pt-32 text-center">
      <p className="text-slate-500">Article not found.</p>
      <Link to="/knowledge" className="text-blue-900 font-medium underline mt-4 inline-block">Back to Knowledge Centre</Link>
    </div>
  );

  return (
    <div className="bg-white pt-24 sm:pt-28" data-testid={`page-article-${slug}`}>
      <article className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/knowledge" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-blue-900">
          <ArrowLeft className="h-4 w-4" /> Knowledge Centre
        </Link>
        <Badge variant="outline" className="mt-6 border-emerald-200 text-emerald-700 bg-emerald-50/60">{article.category}</Badge>
        <h1 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900 leading-[1.1]">
          {article.title}
        </h1>
        <div className="mt-5 flex items-center gap-5 text-xs text-slate-500">
          <span className="inline-flex items-center gap-1"><Calendar className="h-3 w-3" /> {article.date}</span>
          <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" /> {article.read_minutes} min read</span>
        </div>
        <div className="prose prose-slate mt-10 max-w-none text-slate-700 leading-relaxed text-[17px]">
          {article.content.split("\n").map((p, i) => <p key={i} className="mt-5">{p}</p>)}
        </div>

        <div className="mt-14">
          <LeadForm
            title="Have a follow-up question?"
            subtitle="Ask Vinay or a senior advisor directly. No obligation."
            source={`article_${slug}`}
            testIdPrefix={`article-${slug}`}
          />
        </div>
      </article>
    </div>
  );
}
